// extracted by mini-css-extract-plugin
export default {"Buttons":"QuoteTermsButtons_Buttons__V4M55","Buttons_declined":"QuoteTermsButtons_Buttons_declined__zqLWC","Buttons_hidden":"QuoteTermsButtons_Buttons_hidden__1OJsy"};